<template>
  <div class="Transfer__wrapper">
    <div
    :class="{'Transfer--visable': downloadFiles.length}"
    class="Transfer">
      <div class="Transfer__header">
        <div class="Transfer__title">
          <SvgImage
          imageName="FileDownload"
          class="Transfer__header-icon"/>
            Downloading
        </div>
      </div>
      <div
      v-for="item in downloadFiles"
      :key="item.id"
      class="Transfer__element">
        <TransferItem
        :item="item"
        purpose="download"/>
      </div>
    </div>

    <div
    :class="{'Transfer--visable': uploadFiles.length}"
    class="Transfer">
      <div class="Transfer__header">
        <div class="Transfer__title">
          <SvgImage
          imageName="FileUpload"
          class="Transfer__header-icon"/>
            Uploading
          </div>
      </div>
      <div
      v-for="item in uploadFiles"
      :key="item.id"
      class="Transfer__element">
        <TransferItem
        :item="item"
        purpose="upload"/>
      </div>
    </div>
  </div>
</template>

<script>
import TransferItem from '@/components/globals/transfer/item/TransferItem'
import { mapGetters } from 'vuex'

export default {
  name: 'Transfer',

  components: {
    TransferItem
  },

  computed: {
    ...mapGetters('filesTransfer', [
      'downloadFiles',
      'uploadFiles'
    ])
  }
}
</script>

<style lang="scss">
@import 'Transfer';
</style>
